import { cookieStore } from '../scripts/cookie.ts';

export class UrlTransformer {
    protected currentUrl: URL;

    constructor() {
        this.currentUrl = new URL(window.location.href);
    }

    public transform(widget: Widget): Widget {
        widget.widgetInfo.offers.forEach((offer) => {
            offer.url = this.transformUrl(offer.url, widget);
        });

        if (widget.widgetInfo.showcase?.url) {
            const protocol = window.location.protocol ?? 'https:';
            widget.widgetInfo.showcase.url = this.transformShowcaseUrl(
                `${protocol}//${widget.widgetInfo.showcase.url}`,
                widget
            );
        }

        return widget;
    }

    private transformUrl(url: string, widget: Widget): string {
        if (url === '#') {
            return url;
        }

        let link = new URL(url);
        if (widget.constantUrlParamsTool.enabled) {
            widget.constantUrlParamsTool.urlParams.forEach((param) => {
                link.searchParams.set(param.key, param.value);
            });
        }

        if (widget.transferredUrlParamsTool.enabled) {
            widget.transferredUrlParamsTool.urlParams.forEach((param) => {
                const value = this.currentUrl.searchParams.get(param.key)
                if (value) {
                    link.searchParams.set(param.value, value);
                }
            });
        }

        link = cookieStore.addSearchTagsToUrl(link);

        return link.toString();
    }

    private transformShowcaseUrl(url: string, widget: Widget): string {
        if (url === '#') {
            return url;
        }

        let link = new URL(url);

        if (widget.constantUrlParamsTool.enabled) {
            widget.constantUrlParamsTool.urlParams.forEach((param) => {
                link.searchParams.set(param.key, param.value);
            });
        }

        // для витрин мы не применяем трансформацию параметров а передаем как есть
        this.currentUrl.searchParams.forEach((value, key) => {
            link.searchParams.set(key, value);
        });

        link = cookieStore.addSearchTagsToUrl(link);

        return link.toString();
    }
}
